import { createContext } from 'react';
import { SourcePages, Features } from 'lib/EventSchema';

// Using useMemo for this context value would likely have minimal to no impact on INP scores
// The context value is static and doesn’t change frequently
// React's context system is already optimized for re-renders
// Would add unnecessary overhead for such a lightweight operation

export const FilterEventContext = createContext({
  feature: '' as Features,
  sourcePage: '' as SourcePages,
});
